<script setup>
import { cn } from "@/shared/lib/utils";
const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
});
</script>

<template>
  <div
    data-slot="sidebar-header"
    :class="cn('flex flex-col gap-2 ', props.class)"
  >
    <slot />
  </div>
</template>
